export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";